<template>
  <div class="yajintips">
    <div class="popb">
      <div v-if="popShow1" class="box1 pb40 b_fff">
        <img @click="close" src="../assets/img/close1.png" alt="" class="w53 h91 poa b_91 l264">
        <div class="fz32 c_333 pt40 tac por ovh">说明<div class="roll"></div></div>
        <div class="pt30 fz28 c_666 pl40 pr40">
          因会员体系进行调整，原印章租赁服务已关闭。我们将保留您的会员积分，您可选择退还押金或直接将押金转换为: 
          <div class="c_red">年费会员服务(一年)</div>
        </div>
        <div class="pt40 pl40 pr40 tac df jcsb fz30">
          <div @click="showPop2" class="w266 lh80 bdrd50 c_fff b_red">押金转换为会员</div>
          <div @click="showPop3" class="btn2 w206 lh78 bdrd50 c_666">退还押金</div>
        </div>
      </div>

      <div v-if="popShow2" class="box2 pb40 b_fff">
        <div class="fz32 c_333 pt40 tac">提示</div>
        <div class="pt30 fz28 c_666 pl40 pr40 tac">确定转换为年费会员服务(一年) ?</div>
        <div class="pt40 pl40 pr40 tac df jcsb fz30">
          <div @click="submit2" class="w192 lh80 bdrd50 c_fff b_red">确定</div>
          <div @click="close" class="btn2 w190 lh78 bdrd50 c_666">取消</div>
        </div>
      </div>
      <div v-if="popShow3" class="box2 pb40 b_fff">
        <div class="fz32 c_333 pt40 tac">提示</div>
        <div class="pt30 fz28 c_666 pl40 pr40 tac">确定退还押金 ?</div>
        <div class="pt40 pl40 pr40 tac df jcsb fz30">
          <div @click="submit3" class="w192 lh80 bdrd50 c_fff b_red">确定</div>
          <div @click="close" class="btn2 w190 lh78 bdrd50 c_666">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      popShow1:true,
      popShow2: false,
      popShow3:false,
    }
  },
  methods:{
    close(){
      this.$emit('myevent', {close:true})
    },
    showPop2(){
      this.popShow1 = false;
      this.popShow2 = true;
    },
    showPop3(){
      this.popShow1 = false;
      this.popShow3 = true;
    },
    submit2(){
      let vm = this;
      vm.ajax("account/honor/huiyuan", "post", {}, e => {
        this.$emit('myevent', {close:true,refresh:true})
      })
    },
    submit3(){
      let vm = this;
      vm.ajax("account/honor/back", "post", {}, e => {
        this.$emit('myevent', {close:true,refresh:true})
      })
    }
    // POST /account/honor/back 押金退回
  }
}
</script>



// WEBPACK FOOTER //
// src/components/yajintips.vue